module.exports = __webpack_public_path__ + "static/img/Max-Selected.b7dd6af.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/dataSources/Max-Selected.png
// module id = 1758
// module chunks = 0